const WhatIsStaffAugmentation = () => (
  <div className="bg-primary-black pt-16 px-4 pb-32 md:py-20 md:px-8 xl:pt-28 xl:pb-20 xl:]pl-[26rem] xl:pr-0">
    <h2 className="text-4xl md:text-4xl font-medium text-white pb-10">
      <span>What is IT Staff Augmentation?</span>
    </h2>
    <p className="text-base font-normal text-white text-justify w-full md:w-4/5">
      <span>
        Staff augmentation service is a trending business model which allows you
        to fill your job positions with trained IT experts on a contract basis
        from the outsourcing partners. When you are stuck in a position where
        you want people to work on your live projects or your client projects on
        an immediate basis, the IT staff augmentation model allows you to hire
        them on a dedicated basis. <br />
        <br />
        All you need to share as your profile requirements with us, and we will
        be sharing the matching profiles with competitive rates (might be very
        lower compared to your country wages) and with a similar expertise and
        talent you require. They work as part of your team only, they work on
        your projects only and they report to you only. ultroNeous provides IT
        staff augmentation services to clients across the globe and fulfilling
        their urgent needs.
      </span>
    </p>
  </div>
);
export default WhatIsStaffAugmentation;
